import React from 'react';

import { SupportTicketRecordBlock } from '../../types';
import HighlightedText from '../HighlightedText';
import { ResponseActions } from '../ResponseActionButton';
import { useResponseAction } from '../responseActions';
import {
  ResponseHead,
  ResponseIntro,
  ResponsePanel,
  ResponsePanelBody,
  ResponseReply,
  ResponseRow,
  ResponseRows
} from '../responsePrimitives';

/** Figma 6421:9962, the ticket detail panel (6265:4256). */
const SupportTicketRecord: React.FC<{ block: SupportTicketRecordBlock }> = ({ block }) => {
  const emit = useResponseAction(block);
  return (
    <ResponseReply
      $column="replyColumnNarrow"
      data-testid="orbit-response-support_ticket_record"
      data-block-id={block.id}
    >
      {block.intro ? (
        <ResponseIntro>
          <HighlightedText text={block.intro} highlights={block.intro_highlights} />
        </ResponseIntro>
      ) : null}
      <ResponsePanel>
        {block.title ? <ResponseHead title={block.title} icon={block.icon} /> : null}
        <ResponsePanelBody>
          <ResponseRows>
            {block.rows.map(row => (
              <ResponseRow key={row.label} row={row} />
            ))}
          </ResponseRows>
          <ResponseActions actions={block.actions} onAction={emit} />
        </ResponsePanelBody>
      </ResponsePanel>
    </ResponseReply>
  );
};

export default SupportTicketRecord;
